

















































import { defineComponent } from "@vue/composition-api";
import AvailableContentCount from "@/components/AvailabelContentCount";
import BaseButton from "@/components/BaseButton";
import BaseCard from "@/components/BaseCard";
import FormatMoney from "@/components/FormatMoney";
import TextClamp from "@/components/TextClamp";

export default defineComponent({
  name: "CardCost",
  components: { BaseCard, FormatMoney, TextClamp, BaseButton, AvailableContentCount },
  props: {
    buttonText: { type: String },
    title: { type: String },
    description: { type: String },
    processing: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isAvailable: { type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
    deposit: { type: Boolean, default: false },
    cost: { type: Number, required: true },
    currencyCode: { type: String },
    contentCount: { type: Number },
    forceShowContentCount: { type: Boolean, default: false },
  },
});
